module.exports = __webpack_public_path__ + "static/media/toppertje13.47ca9d5c.jpg";